<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<path d="M7,3L4,0L1,3h2v4h2V3H7z M8,12l3-3H9V5H7v4H5L8,12z" />
</svg>
</template>